import React, {createContext, FC, PropsWithChildren, useContext} from 'react'

const MobileContext = createContext<boolean | null>(null)

type MobileProviderProps = PropsWithChildren<{
  isMobile: boolean
}>

export const MobileProvider: FC<MobileProviderProps> = ({children, isMobile}) => {
  return <MobileContext.Provider value={isMobile}>{children}</MobileContext.Provider>
}

export const useMobile = () => {
  const context = useContext(MobileContext)
  if (context === null) {
    throw new Error('useMobile must be used within a MobileProvider')
  }
  return context
}
